import { useState, useEffect, useRef } from "react";

export function usePaginatedQuery<T>({
    lazyHook,
    selectItems,
    perPage = 50,
}: {
    lazyHook: () => [
        (params: { page: number; perPage: number }) => void,
        { data?: any; isLoading: boolean; isFetching: boolean },
        any? // 👈 3rd element ko ignore karne ke liye
    ];
    selectItems: (data: any) => T[];
    perPage?: number;
}) {
    const [page, setPage] = useState(1);
    const [items, setItems] = useState<T[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [isFetchingPage, setIsFetchingPage] = useState(false);
    const lockRef = useRef(false); // ✅ Lock for preventing double fetch

    const [trigger, { data, isLoading }] = lazyHook(); // sirf 2 hi destructure karenge
    useEffect(() => {
        if (hasMore && !isFetchingPage && !lockRef.current) {
            setIsFetchingPage(true);
            lockRef.current = true; // Lock to prevent multiple calls on rapid scroll
            trigger({ page, perPage });
        }
    }, [page]);

    useEffect(() => {
        if (data) {
            const newItems = selectItems(data) || [];
            if (newItems.length > 0) {
                setItems((prev) => [...prev, ...newItems]);
                if (newItems.length < perPage) setHasMore(false);
            } else {
                setHasMore(false);
            }
            setIsFetchingPage(false);
            lockRef.current = false; // Release lock after data processed
        }
    }, [data]);

    const fetchNextPage = () => {
        if (!isFetchingPage && hasMore && !lockRef.current) {
            setPage((prev) => prev + 1);
        }
    };

    return { items, isLoading, hasMore, fetchNextPage };
}

